import { serverBaseUrl, appUrl } from '../utils/config'
import { getCookie } from './cookie'
import packageJson from '../../package.json'

const appVersion = packageJson.version

const login = () => {
  appUrl && window.location.assign(appUrl)
}

export const fetchApi = async (
  api,
  method = 'GET',
  body = null,
  isLoyalty = true,
  version = 2,
  headers = new Headers({
    'content-type': 'application/json',
    'accept': 'application/json',
    'x-agent': `v2.2|passenger|WEBAPP|${appVersion}`,
  }),
) => {
  headers.set('x-authorization', getCookie('token'))
  const fetchOptions = {
    mode: 'cors',
    cache: 'default',
    credentials: 'include',
    method,
    headers,
    body: body ? JSON.stringify(body) : null,
  }
  const loyalty = isLoyalty ? '/loyaltyClub' : ''
  const url = `${serverBaseUrl}/v${version}${loyalty}/${api}`
  try {
    const response = await fetch(url, fetchOptions)
    const responseJson = await response.json()
    if (responseJson.result === 'OK') {
      return responseJson.data
    }
    if (responseJson.result === 'ERR' && responseJson.data) {
      // console.log('resjson', responseJson)
      if (responseJson.data.code === 'INVALID_TOKEN' ||
        responseJson.data.code === 'EXPIRED_TOKEN' ||
        responseJson.data.code === 'PERMISSION_DENIED_FOR_BLOCKED_USER' ||
        responseJson.data.code === 'UNAUTHORIZED_ACCESS'
      ) {
        login()
      }
      if (responseJson.data.code === 'NOT_SIGNED_UP_IN_LOYALTY') {
        return responseJson.data
      }
    }
    return false
  } catch (err) {
    return false
  }
}

export const getLoyalty = () => fetchApi('')
export const register = (isMale, birthDate) => fetchApi('signup', 'POST', { isMale, birthDate })
export const getStore = () => fetchApi('store')
export const getPurchases = (page = 1, limit = 1000) => fetchApi(`purchase/history?page=${page}&limit=${limit}`)
export const getTransactionId = (purchaseId) => fetchApi(`purchase/${purchaseId}`, 'POST')
export const purchase = (transactionId) => fetchApi(`purchase/${transactionId}`, 'PUT')
export const getFAQ = () => fetchApi('faq')
export const getSeasons = () => fetchApi('seasons')
export const getSeasonTransactions = (seasonId, page = 1, limit = 1000) => fetchApi(`season/${seasonId}/transactions?page=${page}&limit=${limit}`)
export const getAd = () => fetchApi('announcement', 'GET', null, false, "2.3")


